export { COACH_BRAND_COLORS } from './constants/brand-colors';
